import { useQuery } from '@tanstack/react-query';
import requests from 'service/api';
import SearchSelect from '../search-select';
import { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';

export function SelectReferanceCode5ZaraHome({ name }) {
  const { values } = useFormikContext();
  const [selected, setSelected] = useState(null);
  const [blacklist, setBlacklist] = useState([]);

  const { data = [], isFetched } = useQuery({
    queryKey: ['/list', 'referance'],
    queryFn: async () => {
      try {
        const { data } = await requests.referance.list();
        console.log('Gelen Data:', data); // Gelen veriyi konsola yazdır
        return data;
      } catch (error) {
        console.error('API Error:', error);
        return []; // Hata durumunda boş bir dizi döndür
      }
    },
    placeholderData: [], // Başlangıçta boş bir dizi
  });

  // Kara liste kodlarını oluştur
  useEffect(() => {
    const blacklistedCodes = Array.from(
        { length: 39 - 19 + 1 },
        (_, i) => `WPZCALL${String(i + 19).padStart(3, "0")}`
    ).filter(code => !["WPZCALL022", "WPZCALL023"].includes(code)); // 22, 23 ve 24 hariç tut

    setBlacklist(blacklistedCodes);
    console.log("Blacklist Kodları:", blacklistedCodes);
}, []);


  // Gelen veriyi filtrele (BLACKLIST UYGULANDI)
  const isWasgingLabel = Array.isArray(data)
    ? data.filter(
        (item) =>
          item.labelCategory === 'ZARAHOME MARKA KARTI' &&
          !blacklist.includes(item.code) // Kara listedeki kodları çıkar
      )
    : [];

  console.log("Filtrelenmiş Data (Blacklist Hariç):", isWasgingLabel);

  // Filtrelenmiş veriyi dropdown seçeneklerine dönüştür
  const options = isWasgingLabel.map(({ id, code }) => ({
    value: id,
    label: code,
  }));

  useEffect(() => {
    console.log('Formik Values:', values); // Formik values değerini konsola yazdır
    if (values?.brandLabel?.[0]?.referanceCode && isFetched) {
      const select = options.find(({ value }) => value === values.brandLabel[0].referanceCode);
      setSelected(select || null); // Eşleşme bulunamazsa null olarak ayarla
    }
    // eslint-disable-next-line
  }, [values, isFetched]);

  return (
    <SearchSelect
      name={name}
      label="Referans Kodu"
      options={options}
      value={selected || null} // `selected` boşsa null döndür
      onChange={(e) => setSelected(e)}
    />
  );
}
